module.exports = __webpack_public_path__ + "images/home/devices-bf2d9a30130324ab532f8c86679bfe61.png";